import { render, staticRenderFns } from "./localization.vue?vue&type=template&id=f88dcad6&scoped=true&"
import script from "./localization.vue?vue&type=script&lang=js&"
export * from "./localization.vue?vue&type=script&lang=js&"
import style0 from "./localization.vue?vue&type=style&index=0&id=f88dcad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88dcad6",
  null
  
)

export default component.exports